import React, {useCallback, useEffect, useMemo, useRef, useState,} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import ChartFilter from "./ChartFilter";
import ChartOfAccountsFrom from "./ChartOfAccountsForm";
import {AgGridReact} from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
// import EditRenderer from "./EditRenderer";
import {IconButton, Tooltip} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import {confirmAlert} from "react-confirm-alert";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import {Box} from "@mui/system";
import {styled} from "@mui/material/styles";

const processData = (data) => {
  const flattenedData = [];
  const flattenRowRecursive = (row, parentPath, parentType) => {
    const dataPath = [...parentPath, row.name];
    const dataType = [...parentType, row.shortForm];
    flattenedData.push({ ...row, dataPath, dataType });
    if (row.children) {
      row.children.forEach((children) =>
        flattenRowRecursive(children, dataPath, dataType)
      );
    }
  };
  data.forEach((row) => flattenRowRecursive(row, [], []));
  return flattenedData //.filter((item) => !item.deleteStatus);
};

//*************************//
let lastLeafId = 3;

const EditRenderer = (props) => {
  return (
    <span>
      <Tooltip title={"Edit"}>
        <IconButton onClick={() => props.handleEditDialogOpen(props.data)}>
          <FuseSvgIcon size={14} color="action">
            heroicons-outline:pencil
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={"View"}>
        <IconButton onClick={() => props.handleViewDialogOpen(props.data)}>
          <FuseSvgIcon size={14} color="action">
            heroicons-outline:document-search
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={"Add"}>
        <IconButton
          onClick={() => props.handleAddCurrentDialogOpen(props.data)}
        >
          <FuseSvgIcon size={14} color="action">
            heroicons-outline:plus-sm
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
    </span>
  );
};

const ColorGrid = styled(Box)(({ theme }) => ({
  "& .rag-head-outer": {
    backgroundColor: "#1F252A",
  },
  "& .rag-group-outer": {
    backgroundColor: "#252B31",
  },
  "& .rag-general-ledger-outer": {
    backgroundColor: "#353C44",
  },
  "& .rag-ledger-outer": {
    backgroundColor: "#3D4853",
  },
  "& .rag-sub-ledger-outer": {
    backgroundColor: "#404D5A",
  },
}));

const SelectEditorComponent = () => {
  var typeFilterModel = gridRef.current.api.getFilterModel();
  const op = filterAccountsByName(data, typeFilterModel);
  setRowData(processData(op));
};

const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.chartOfAccount}`;
const chartOfAccount2s = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.chartOfAccount2s}`;

const ChartOfAccounts = () => {
  const [gridApi, setGridApi] = useState(null);
  const [open, setOpen] = useState(false);
  const [openCurrentRow, setOpenCurrentRow] = useState(false);
  const [openRow, setOpenRow] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editRow, setEditRow] = useState();
  const [viewRow, setViewRow] = useState();
  const [AddCurrentRow, setAddCurrentRow] = useState();
  const [openEditRow, setOpenEditRow] = useState(false);
  const [openViewRow, setOpenViewRow] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState([]);
  const [childRow, setChildRow] = useState();
  const [headRow, setHeadRow] = useState();
  const gridRef = useRef();
  const [error, setError] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(true);
  const [expand, setExpand] = useState(false);
  const [checkSubmit, setCheckSubmit] = useState(false);

  const handleEditDialogOpen = (event) => {
    setOpenEditRow(true);
    setEditRow(event);
  };

  const handleViewDialogOpen = (node) => {
    setOpenViewRow(true);
    setViewRow(node);
  };
  const handleAddCurrentDialogOpen = (node) => {
    setOpenCurrentRow(true);
    setAddCurrentRow(node);
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "shortForm",
      headerName: "Account Type",
      minWidth: 200,
      maxWidth: 200,
      valueFormatter: (params) => params.value ? params.value.replace(/_/g, " ") : "",
    },
    { field: "code", headerName: "Code", maxWidth: 150 },
    {
      headerName: "Action",
      cellRenderer: (data) => (
        <EditRenderer
          data={data}
          handleEditDialogOpen={handleEditDialogOpen}
          handleViewDialogOpen={handleViewDialogOpen}
          handleAddCurrentDialogOpen={handleAddCurrentDialogOpen}
        />
      ),
      maxWidth: 200,
    },
  ]);
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      floatingFilter: true,
      sortable: true,
      resizable: true,
      filter: 'agMultiColumnFilter',
    };
  }, []);
  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "Chart of Account",
      field: "name",
      //filter: "agSetColumnFilter",
      cellRendererParams: {
        suppressCount: true,
      },
    };
  }, []);
  const getDataPath = useMemo(() => {
    return (data) => data.dataPath;
  }, []);
  const getRowId = useMemo(() => {
    return (params) => params.data.id;
  }, []);
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  const loadData = async () => {
    try {
      const list = await OAuthService.getList(`${url}/findAllHeadAccount`);
      let data = list?.data;
      setRowData(processData(data));
      setData(data);
    } catch (error) {
      setError(error.message);
    }
  };
  useEffect(() => {
    loadData();
  }, []);

  const handleClose = () => {
    setOpen(false);
    setOpenRow(false);
    setOpenEditRow(false);
    setOpenViewRow(false);
    setOpenCurrentRow(false);
  };

  const valueFromAccountType = (key) => {
    switch (key) {
      case "HEAD":
        return "GROUP";
      case "GROUP":
        return "GENERAL_LEDGER";
      case "GENERAL_LEDGER":
        return "LEDGER";
      case "LEDGER":
        return "SUB_LEDGER";
      case "SUB_LEDGER":
        return "SUB_LEDGER";

      default:
        return "GENERAL_LEDGER";
    }
  };

  const getContextMenuItems = (event) => {
    return event?.node !== null?
        [
      // {
      //   name: "Add Account HEAD",
      //   icon: '<span><i class="material-icons style="font-size: 18px">add</i></span>',
      //   action: () => {
      //     handleAddHeadDialogOpen(event);
      //   },
      //   disabled: event?.node === null
      // },
      {
        name: `Add Account ${valueFromAccountType(event?.node?.data?.accountType).replace(
          /_/g,
          " "
        )}`,
        // name: `Add`,
        icon: '<span><i class="material-icons style="font-size: 18px">add</i></span>',
        action: () => {
          handleAddDialogOpen(event);
        },
        disabled: event?.node?.data?.accountType === 'SUB_LEDGER' || event?.node === null
      },
      {
        name: `Update Account ${event?.node !== null ? event?.node?.data?.name : ""}`,
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: () => {
          // onEdit(event);
          handleEditDialogOpen(event);
        },
        disabled: event?.node === null
      },
      {
        name: "View Account",
        icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
        action: () => {
          handleViewDialogOpen(event);
        },
        disabled: event?.node === null
      },
      {
        name: "Delete Account",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onDelete(event);
        },
        disabled: event?.node === null
      },
    ]:null;
  };
  function addChildToAddress(data, address, newChild) {
    let currentLevel = data;
    for (const node of address) {
      const nodeId = node.id;
      const currentNode = currentLevel.find((item) => item.id === nodeId); // item.id === nodeId
      if (currentNode) {
        currentLevel = currentNode.children;
      } else {
        // Node not found, handle the error or break the loop
        console.log("Node not found!");
        return data;
      }
    }
    currentLevel.push(newChild);
    return data;
  }

  function editChildToAddress(data, address, editRow) {
    let currentLevel = data;
    console.log("currentLevel", currentLevel);
    const lastAddress = address[address.length - 1];
    for (const node of address) {
      const nodeId = node.id;
      let currentNode = currentLevel.find((item) => item.id === nodeId);

      if (currentNode && nodeId === lastAddress.id) {
        currentLevel = currentNode.children;
        currentNode.name = editRow.accountName;
        currentNode = {
          ...currentNode,
          ...editRow,
        };
        console.log("currentLevel IF", currentLevel, editRow.accountName);
        // currentLevel.name =
      } else if (currentNode) {
        currentLevel = currentNode.children;
      } else {
        // Node not found, handle the error or break the loop
        console.log("Node not found!");
        return data;
      }
    }

    // currentLevel[currentLevel.length - 1].name = editRow.accountName;
    return data;
  }

  const createTree = (node) => {
    let tree = [];
    let temp = (item) => {
      tree.push({
        level: item.level, // 2
        childIndex: item.rowIndex - item.level, // - item.level, // 2 - 2
        id: item.data.id,
      });
      if (item.level > 0) {
        temp(item.parent);
      }
    };
    temp(node);
    tree = tree.sort((a, b) => a.level - b.level);
    return tree;
  };

  const onAddHeadRow = async (event, values, selectedCompany, companyName, accountName) => {
    // const selectedRow = [event.node.data]; //gridRef.current.api.getSelectedRows();
    const newChild = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      name: accountName,
      code: values.accountCode,
      shortForm: values.accountType.value,
      children: [],
      accountType: values.accountType.value,
      assetAccount: values.assetAccount.value,
      balanceSheet: values.balanceSheet.value,
      balanceType: values.balanceType.value,
      budget: values.budget.value,
      cashFlow: values.cashFlow.value,
      consolidation: values.consolidation.value,
      corporateTax: values.corporateTax.value,
      costCenter: values.costCenter.value,
      costObject: values.costCenter.value,
      currency: values.currency.value,
      profitAndLoss: values.profitLoss.value,
      trialBalance: values.trialBalance.value,
      vat: values.vat.value,
    };
    await OAuthService.addData(`${url}/createChartAccount`, newChild);
    loadData();
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
  };

  const onAdd = async (event, values, selectedCompany, companyName, accountName) => {
    // console.log('add values', values)
    setCheckSubmit(true);
    const newChild = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      name: accountName,
      shortForm: values.accountType.value,
      code: values.accountCode,
      parentId: event.node.id,
      accountType: values.accountType.value,
      balanceType: values.balanceType.value,
      costCenter: values.costCenter.value,
      costObject: values.costObject.value,
      budget: values.budget.value,
      cashFlow: values.cashFlow.value,
      assetAccount: values.assetAccount.value,
      trialBalance: values.trialBalance.value,
      profitAndLoss: values.profitLoss.value,
      balanceSheet: values.balanceSheet.value,
      vat: values.vat.value,
      corporateTax: values.corporateTax.value,
      consolidation: values.consolidation.value,
      currency: values.currency.value,
    };

    // const tree = createTree(event.node);
    // const lastChild = tree[tree.length - 1];
    // console.log('tree', tree)
    // const firstChild = tree[0];
    // const updatedData = addChildToAddress(data, tree, newChild);
    // const id = event.node.id
    // console.log('newChild', newChild)
    // console.log('updatedData', updatedData)
    await OAuthService.putData(`${url}/update`, newChild);
    loadData();
    setSuccessMsg("Data Added Successfully");
    setSnackState(true);
    // setRowData(processData(updatedData));

    // console.log('updatedData', updatedData)
    // try {
    //   OAuthService.putData(addUrl + `/${lastChild.id}`, updatedData);
    //   // loadDate()
    //   setRowData(processData(updatedData));
    // } catch (error) {
    //   console.log("error", error);
    //   // setError(error.message)
    //   // return true
    // }
  };

  const addAccountTypeRow = async (
    event,
    values,
    selectedCompany,
    companyName,
    accountName
  ) => {
    const payload = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      name: accountName,
      shortForm: values.accountType.value,
      code: values.accountCode,
      accountType: values.accountType.value,
      balanceType: values.balanceType.value,
      costCenter: values.costCenter.value,
      costObject: values.costObject.value,
      budget: values.budget.value,
      cashFlow: values.cashFlow.value,
      assetAccount: values.assetAccount.value,
      trialBalance: values.trialBalance.value,
      profitAndLoss: values.profitLoss.value,
      balanceSheet: values.balanceSheet.value,
      vat: values.vat.value,
      corporateTax: values.corporateTax.value,
      consolidation: values.consolidation.value,
      currency: values.currency.value,
    };
    const headType = {
      ...payload,
      children: [],
    };
    const accountType = {
      ...payload,
      parentId: event.node.parent.id,
    };
    if (values.accountType.value === "HEAD") {
      await OAuthService.addData(`${url}/createChartAccount`, headType);
    } else {
      await OAuthService.putData(`${url}/update`, accountType);
    }
    loadData();
    setSuccessMsg("Data Added Successfully");
    setSnackState(true);
  };

  const onEdit = async (event, values, accountName) => {
    const editChild = {
      name: accountName,
      shortForm: values.accountType.value,
      code: values.accountCode,
      id: event.node.id,
      parentId: event.node.parent.data ? editRow.node.parent.data.id : "",
      accountType: values.accountType.value,
      balanceType: values.balanceType.value,
      costCenter: values.costCenter.value,
      costObject: values.costObject.value,
      budget: values.budget.value,
      cashFlow: values.cashFlow.value,
      assetAccount: values.assetAccount.value,
      trialBalance: values.trialBalance.value,
      profitAndLoss: values.profitLoss.value,
      balanceSheet: values.balanceSheet.value,
      vat: values.vat.value,
      corporateTax: values.corporateTax.value,
      consolidation: values.consolidation.value,
      currency: values.currency.value,
    };
    // console.log('edit payload', editChild)
    await OAuthService.putData(`${url}/update`, editChild);
    loadData();
    setSuccessMsg("Data Updated Successfully");
    setSnackState(true);
    // const tree = createTree(editRow.node);
    // const lastChild = tree[tree.length - 1];
    // const updatedData = editChildToAddress(data, tree, values);
    // setRowData(processData(updatedData));
    // try {
    //   OAuthService.putData(addUrl + `/${lastChild.id}`, values);
    //   // loadDate()
    //   //setRowData(processData(updatedData));
    // } catch (error) {
    //   console.log("error", error);
    //   // setError(error.message)
    //   // return true
    // }
    //setData(updatedData);
    //setRowData(processData(updatedData));
  };

  const onDelete = useCallback(
    (event) => {
      const selectedRow = [event.node.data];
      const id = event.node.id;
      const payload = {
        id: event.node.id,
        parentId: event.node.parent.data ? event.node.parent.data.id : "",
        accountType: event.node.data.accountType,
      };
      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              // console.log('delete payload', payload)
              // rowData.splice(event.node.rowIndex, 1);
              // gridRef.current.api.applyTransaction({ remove: selectedRow });
              try {
                await OAuthService.deleteData(`${url}/deleteAccount`, id, payload);
                loadData();
                setError('')
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
                
              } catch (error) {
                setError(error?.response?.data?.errorMessage || error.message)
              }
              // if (!event.node.data.deleteStatus) {
              //   event.node.displayed = false;
              //   console.log("event", event);
              // }
              // selectedRow.map(async (row) => {
              //   const id = row.id;
              //   await OAuthService.deleteData(`${url}/deleteAccount`, payload);
              //   setSuccessMsg("Data deleted Successfully");
              //   setSnackState(true);
              // });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });

      // selectedRow.map(async (row) => {
      //   await OAuthService.deleteData(productUrl, row.id);
      // });
    },
    [gridRef, rowData]
  );

  const handleAddDialogOpen = (node) => {
    setOpen(true);
    setChildRow(node);
  };

  const handleAddHeadDialogOpen = (node) => {
    setOpenRow(true);
    setHeadRow(node);
  };

  const onFilterTextBoxChanged = useCallback((value) => {
    gridRef.current.api.setQuickFilter(value);
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ChartOfAccounts.xlsx",
      sheetName: "Chart Of Accounts",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const rowClassRules = {
    "rag-head-outer": function (params) {
      return params?.data?.accountType === "HEAD";
    },
    "rag-group-outer": function (params) {
      return params?.data?.accountType === "GROUP";
    },
    "rag-general-ledger-outer": function (params) {
      return params?.data?.accountType === "GENERAL_LEDGER";
    },
    "rag-ledger-outer": function (params) {
      return params?.data?.accountType === "LEDGER";
    },
    "rag-sub-ledger-outer": function (params) {
      return params?.data?.accountType === "SUB_LEDGER";
    },
  };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.expandAll();
  }, []);

  const onBtPrint = useCallback(() => {
    const api = gridRef.current.api;
    // api.setDomLayout("print");
    setPrinterFriendly(api);
    setTimeout(function () {
        print();
        setNormal(api)
    }, 2000);
  }, [print]);

  const setPrinterFriendly = (api) => {
    const eGridDiv = document.getElementById('chartOfAccountGrid');
    eGridDiv.style.width = '';
    eGridDiv.style.height = '';
    api.setDomLayout('print');
}

function setNormal(api) {
    const eGridDiv = document.getElementById('chartOfAccountGrid');
    eGridDiv.style.width = '';
    eGridDiv.style.height = '';
    api.setDomLayout();
}

  const filterAccountsByName = (data, searchTerm) => {
    let filteredAccounts = [];

    for (let account of data) {
      if (account.name && account.name.includes(searchTerm)) {
        filteredAccounts.push({ ...account, children: [] });
      }

      if (account.children && account.children.length > 0) {
        let children = filterAccountsByName(account.children, searchTerm);
        filteredAccounts = filteredAccounts.concat(children);
      }
    }

    return filteredAccounts;
  }

  const searchValue = (value) => {
    if (value !== "" && value !== null) {
      const op = filterAccountsByName(data, value);
      setRowData(processData(op));
    } else {
      setRowData(processData(data));
    }
  };

  const filterChanged = (params) => {
    const { api, columnApi } = params;
    const filterModel = api.getFilterModel();
    const filterObj = {};
    Object.entries(filterModel).map(([key, value]) => {
      const values = value.filterModels[0]?.filter ?? value.filterModels[1].values;
      filterObj[key.replace("ag-Grid-AutoColumn", "name")] = values;
    });
    const allData = [];
    api.forEachNode((node) => {
      const { data } = node;
      data.children = [];
      allData.push(data);
    });
    if (JSON.stringify(filterObj) === "{}") {
      setRowData(processData(data));
    } else {
      setRowData(processData(allData));
    }
  }
  const expandAll = useCallback(() => {
    gridRef.current.api.expandAll();
  }, []);

  const collapseAll = useCallback(() => {
    gridRef.current.api.collapseAll();
  }, []);

  const btnExpand = useCallback(() => {
    setExpand(!expand)
    if(expand) {
      gridRef.current.api.expandAll();
    } else {
      gridRef.current.api.collapseAll();
    }
  }, [expand])


  return (
    <>
      <ListPageHeader
        componentName="Chart of Accounts"
        onBtExport={onBtExport}
        //handlePurge={handlePurge}
        //handleAddButton={handleAddButton}
        pageName="Chart of Accounts"
        //headerInputFields={exchangeRateFilter()}
        error={error}
        //deleteDisable={deleteDisable}
        successMsg={successMsg}
        // gridRef={gridRef}
        snackState={snackState}
        showPaginationDropdown={showPaginationDropdown}
        onBtPrint={onBtPrint}
        isExpand={expand}
        onExpandClick={btnExpand}
        onAddHeadClick={handleAddHeadDialogOpen}
      />
      {/* <ChartWidgets /> */}
      {/*<ChartFilter*/}
      {/*  rowData={processData(data)}*/}
      {/*  searchValue={searchValue}*/}
      {/*  onFilterTextBoxChanged={onFilterTextBoxChanged}*/}
      {/*  btnExpand={btnExpand}*/}
      {/*  expand={expand}*/}
      {/*  handleAddHeadDialogOpen={handleAddHeadDialogOpen}*/}
      {/*/>*/}
      <ColorGrid
        id="chartOfAccountGrid"
        className="h-full pr-24 pl-24 ag-theme-alpine-dark grid pt-24"
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          treeData={true}
          animateRows={true}
          groupDefaultExpanded={-1}
          getDataPath={getDataPath}
          getRowId={getRowId}
          onGridReady={onGridReady}
          onFilterChanged={filterChanged}
          getContextMenuItems={getContextMenuItems}
          rowClassRules={rowClassRules}
          headerHeight={28}
          rowHeight={22}
          onFirstDataRendered={onFirstDataRendered}
        />
      </ColorGrid>
      <ChartOfAccountsFrom
        open={open}
        openRow={openRow}
        openEditRow={openEditRow}
        openViewRow={openViewRow}
        openCurrentRow={openCurrentRow}
        handleClose={handleClose}
        onAdd={onAdd}
        childRow={childRow}
        headRow={headRow}
        onEdit={onEdit}
        editRow={editRow}
        viewRow={viewRow}
        onAddHeadRow={onAddHeadRow}
        AddCurrentRow={AddCurrentRow}
        addAccountTypeRow={addAccountTypeRow}
        data={data}
        processedData = {processData(data)}
        checkSubmit={checkSubmit}
      />
    </>
  );
};

export default ChartOfAccounts;
